import api from '../api/icaro';


// Listar todos os itens, com filtro opcional
export async function getCategories(params) {
  const { data } = await api.get('/categories', { params });
  return data;
}

// Buscar item por ID
export async function getCategory(id) {
  const { data } = await api.get(`/categories/${id}`);
  return data;
}

// Criar item
export async function storeCategory(item) {
  const { data } = await api.post('/categories', item);
  return data;
}

// Atualizar item
export async function updateCategory(id, item) {
  const { data } = await api.put(`/categories/${id}`, item);
  return data;
}

// Excluir item
export async function deleteCategory(id) {
  await api.delete(`/categories/${id}`);
}
